import React from "react";
import { Typography } from "@material-ui/core";

const FeatureEligibilityCard = ({
  title,
  items = [],
  image,
  imagePosition = "left",
  headerColor = "#00B140",
  classes,
}) => {
  return (
    <div className={classes.infoCard}>
      <div
        className={classes.cardHeader}
        style={{ backgroundColor: headerColor }}
      >
        <Typography
          variant="h5"
          style={{
            color: "#fff",
            fontWeight: 700,
          }}
        >
          {title}
        </Typography>
      </div>

      <div className={classes.cardBody}>
        {imagePosition === "left" && image && (
          <div className={classes.imageWrapper}>
            <img
              src={image}
              alt={title}
              className={classes.cardImage}
            />
          </div>
        )}

        <div className={classes.listWrapper}>
          {items.map((item, index) => (
            <div
              key={index}
              className={classes.listItem}
            >
              <div className={classes.numberCircle}>
                {String(index + 1).padStart(2, "0")}
              </div>

              <span
                className={classes.itemText}
              >
                {item}
              </span>
            </div>
          ))}
        </div>

        {imagePosition === "right" && image && (
          <div className={classes.imageWrapper}>
            <img
              src={image}
              alt={title}
              className={classes.cardImage}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default FeatureEligibilityCard;